import * as exUtils from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        showTooltip(config: Record<string, any>): void;
        hideTooltip(config: Record<string, any>): void;
        disposeTooltip(config: Record<string, any>): void;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.showTooltip = function (config: Record<string, any>): void {
    exUtils.show(this, config);
};

HTMLElement.prototype.hideTooltip = function (config: Record<string, any>): void {
    exUtils.hide(this, config);
};

HTMLElement.prototype.disposeTooltip = function (config: Record<string, any>): void {
    exUtils.dispose(this, config);
};
